<template>
  <ProjectDetailLayout>
    <template #breadcrumbs>
      <v-breadcrumbs :items="items" />
    </template>
    <template #heading>
      <ProjectHeading :loading="loading" :id="id" />
    </template>
    <template #tabs>
      <v-tabs grow v-model="tabs" class="elevation-1">
        <v-tab :to="{ name: 'ProjectSummaryView', params: { id: id } }">
          Summary
        </v-tab>
        <v-tab :to="{ name: 'ProjectWorkOrderListView', params: { id: id } }">
          WorkOrders
        </v-tab>
        <v-tab :to="{ name: 'ProjectBatchListView', params: { id: id } }">
          Batches
        </v-tab>
        <v-tab :to="{ name: 'ProjectQualityListView', params: { id: id } }">
          Quality
        </v-tab>
        <v-tab :to="{ name: 'ProjectShippingListView', params: { id: id } }">
          Shipped
        </v-tab>
        <v-tab disabled>
          <v-chip x-small>Coming Soon</v-chip>
          <!-- Add History -->
        </v-tab>
      </v-tabs>
    </template>
    <template #content>
      <v-skeleton-loader type="article" v-if="loading" />
      <router-view v-else :id="id" />
    </template>
  </ProjectDetailLayout>
</template>

<script>
import Project from "../../models/Project";
import ProjectDetailLayout from "../../layouts/ProjectDetailLayout";
import ProjectHeading from "../../components/Project/ProjectHeading";
export default {
  name: "ProjectDetailView",
  components: { ProjectHeading, ProjectDetailLayout},
  props: {
    id: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      loading: true,
      tabs: null,
      items: [
        {
          text: 'Project',
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'WorkOrder',
          disabled: true,
          href: 'breadcrumbs_link_1',
        },
        {
          text: 'Batch',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ]
    }
  },
  methods: {
    initialize() {
      this.loading = true;
      Project.$get(this.id)
        .then(() => this.loading = false)
    }
  },
  created() {
    this.initialize()
  }
}
</script>
